"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _recommended = require("@/api/recommended");
var _imageUpload = _interopRequireDefault(require("@/components/image-upload"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    ImageUpload: _imageUpload.default
  },
  props: {
    manageType: {
      type: String,
      default: ''
    },
    ruleForm: {
      product_id: '',
      icon: ''
    },
    allProductList: {
      type: Array | String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      listData: {
        product_id: '',
        icon: ''
      },
      iconUrl: {
        img_url: ''
      },
      rules: {
        product_id: {
          required: true,
          message: '请选择所属产品product_id',
          trigger: 'blur'
        }
      }
    };
  },
  watch: {
    ruleForm: function ruleForm(value) {
      var product_id = value.product_id,
        icon = value.icon;
      var obj = {
        product_id: product_id,
        icon: icon
      };
      this.listData = obj;
      this.iconUrl.img_url = icon;
    }
  },
  methods: {
    onCancel: function onCancel() {
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      var iconUrlUpload = this.$refs.iconUrlUpload.validateData();
      this.$refs[formName].validate(function (valid) {
        if (valid && iconUrlUpload) {
          _this.handleEvent();
        } else {
          return false;
        }
      });
    },
    handleEvent: function handleEvent() {
      var _this2 = this;
      var product_id = this.listData.product_id;
      var req = {
        product_id: product_id,
        icon: this.iconUrl.img_url
      };
      (0, _recommended.editProductIcon)(req).then(function (_ref) {
        var code = _ref.code,
          msg = _ref.msg;
        if (code === 200) {
          _this2.$message({
            message: msg,
            type: 'success'
          });
          _this2.dialogVisible = false;
          _this2.$parent.getList(); // 更新父组件数据
        }
      }).catch();
    }
  }
};